// extracted by mini-css-extract-plugin
module.exports = {"body":"styles_body__3h5Dr","actions":"styles_actions__3BjNe"};